import { IProduct } from "@tactful/sdk";
import { store } from "@/store"; 
const urlTemplate = require('url-template');

export class Webviews {

    constructor() { }

    getExternalLink(externalLinkTemp: string, product: IProduct) {
        let externalLinkUrl, externalLink;
        if (externalLinkTemp)
            externalLink = urlTemplate.parse(externalLinkTemp);
        externalLinkUrl = decodeURIComponent(externalLink.expand(product));

        return externalLinkUrl;
    }
    getWebviewProductUrl(product: IProduct) {
        let externalLinkUrl = "";
        if (store.profile.state.settings.external_link_template && store.profile.state.settings.enable_external_link) {
            externalLinkUrl = this.getExternalLink(store.profile.state.settings.external_link_template, product);
        } else {
            console.log(`err in productdetails at getProductUrl`);
        }
        return externalLinkUrl;

    }
}